import { CartAddEvent } from '@theme/events';
import { fetchConfig } from '@theme/utilities';

if (!window.__BZ_AOV_ENGINE__) {
  window.__BZ_AOV_ENGINE__ = true;

  document.addEventListener('click', async (event) => {
    const qtyButton = event.target.closest('.bz-aov-engine [data-bz-aov-qty] [data-qty]');
    if (qtyButton) {
      const root = qtyButton.closest('.bz-aov-engine');
      const qty = Math.max(1, Number(qtyButton.dataset.qty || 1));
      root?.querySelectorAll('[data-bz-aov-qty] [data-qty]').forEach((button) => {
        const active = button === qtyButton;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      const section = root?.closest('.shopify-section') || document;
      const form =
        section.querySelector('product-form-component form[action*="/cart/add"]') ||
        section.querySelector('form[action*="/cart/add"]');
      const input = form?.querySelector('input[name="quantity"]');

      if (input) {
        input.value = String(qty);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    const add = event.target.closest('.bz-aov-engine [data-bz-aov-add]');
    if (!add || add.dataset.loading === 'true') return;

    const variantId = add.dataset.variantId;
    const productId = add.dataset.productId || '';
    if (!variantId) return;

    const sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
      .map((element) => element.dataset.sectionId)
      .filter(Boolean);

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    if (sectionIds.length) formData.append('sections', sectionIds.join(','));
    formData.append('sections_url', window.location.pathname);

    const originalText = add.textContent;
    add.dataset.loading = 'true';
    add.textContent = '…';

    try {
      const cfg = fetchConfig('javascript', { body: formData });
      const response = await fetch('/cart/add.js', {
        ...cfg,
        headers: { ...cfg.headers, Accept: 'text/html' },
      });
      const data = await response.json();
      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'Ürün sepete eklenemedi.');
      }

      document.dispatchEvent(
        new CartAddEvent(data, variantId, {
          source: 'bz-aov-engine',
          itemCount: 1,
          productId,
          variantId,
          sections: data.sections || {},
        })
      );

      add.textContent = '✓';
      window.setTimeout(() => {
        add.textContent = originalText;
        add.dataset.loading = 'false';
      }, 900);
    } catch (error) {
      console.error(error);
      add.textContent = '!';
      add.dataset.loading = 'false';
    }
  });
}